import React from 'react';
import CreateTicketForm from '../../portal/tickets/CreateTicketForm';

const AgentCreateTicket = () => {
  return (
    <div className="space-y-6">
      <CreateTicketForm
        source="agent"
        redirectPath="/agent/tickets/my-tickets"
        title="Log Customer Ticket"
        subtitle="Capture the issue details and route it to the right queue."
        phoneNumber={null}
      />
    </div>
  );
};

export default AgentCreateTicket;

